var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tabs',{staticClass:"tab-list center-block",on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},_vm._l((_vm.navTabs),function(item,index){return _c('el-tab-pane',{key:index,attrs:{"label":item.label,"name":'page' + index}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }